import React from 'react';
import { connect } from 'react-redux';
import { startLogin } from '../actions/auth';


export const ExpenseLoginPage = ({ startLogin }) => (
    <div className="box-layout">
        <div className="box-layout__box">
            <h1 className="box-layout__title">Expenses</h1>
            <p>Record and manage your expenses from any device.</p>
            <button className="button" onClick={startLogin}>Login with Google</button>
        </div>
    </div>

)

const mapDispatchToProps = (dispatch) => ({
    startLogin: () => dispatch(startLogin())
})


export default connect(undefined, mapDispatchToProps)(ExpenseLoginPage)


// WEBPACK FOOTER //
// ./src/components/ExpenseLoginPage.js